var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHospital(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 20,
    viewBox: "0 0 14 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 1.44995,
    width: 0.95,
    height: 17.1,
    fill: "#232323"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 7.6001,
    y: 1.44995,
    width: 0.95,
    height: 9.5,
    fill: "#232323"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 0.949707,
    y: 0.5,
    width: 6.65,
    height: 0.95,
    fill: "#232323"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 1.8999,
    y: 3.3501,
    width: 1.9,
    height: 1.9,
    fill: "#232323"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 1.8999,
    y: 6.19995,
    width: 1.9,
    height: 1.9,
    fill: "#232323"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 1.8999,
    y: 9.05005,
    width: 1.9,
    height: 1.9,
    fill: "#232323"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 4.75,
    y: 3.3501,
    width: 1.9,
    height: 1.9,
    fill: "#232323"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 4.75,
    y: 6.19995,
    width: 1.9,
    height: 1.9,
    fill: "#232323"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 4.75,
    y: 9.05005,
    width: 1.9,
    height: 1.9,
    fill: "#232323"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 0.949707,
    y: 18.55,
    width: 11.4,
    height: 0.95,
    fill: "#232323"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 7.6001,
    y: 10,
    width: 4.75,
    height: 0.95,
    fill: "#232323"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 12.3501,
    y: 10.95,
    width: 0.95,
    height: 7.6,
    fill: "#232323"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 3.7998,
    y: 13.8,
    width: 0.95,
    height: 4.75,
    fill: "#232323"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 8.5498,
    y: 13.8,
    width: 0.95,
    height: 4.75,
    fill: "#232323"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 4.75,
    y: 12.8501,
    width: 3.8,
    height: 0.95,
    fill: "#232323"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHospital);
export default __webpack_public_path__ + "static/media/hospital.216916ea8a25da281426f834449d7753.svg";
export { ForwardRef as ReactComponent };